/* eslint-disable sonarjs/no-duplicate-string */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axiosClient from '@ui-core/config/axiosClient';
import axios from 'axios';
import * as qs from 'qs';
import { toast } from 'react-toastify';
import { Dispatch } from 'redux';
import { toastConfig } from '../SSONavItem/utils/constants';
import {
    BodyRequest,
    BodyUpdate,
    EnterpriseAutocomplete,
    Filters,
    Request,
    RequestListResponse,
    Results
} from './RequestTypes';
import { useSelector } from 'react-redux';
import { AppState } from 'app/App.store';
export interface RequestLinkedBusinesses {
    loadingRequest: boolean;
    wasFetchedRequest: boolean;
    requestResponseData: RequestListResponse;
    errorRequest: boolean;
    errorMessageRequest: string;
    loadingEnterpriseAutocomplete: boolean;
    wasFetchedEnterpriseAutocomplete: boolean;
    enterpriseAutocompleteData: Array<EnterpriseAutocomplete>;
    errorEnterpriseAutocomplete: boolean;
    errorMessageEnterpriseAutocomplete: string;
    loadingPostRequest: boolean;
    wasFetchedPostRequest: boolean;
    postRequestData: Request;
    errorPostRequest: boolean;
    errorMessagePostRequest: string;
    loadingDeleteRequest: boolean;
    wasFetchedDeleteRequest: boolean;
    deleteRequestData: Request;
    errorDeleteRequest: boolean;
    errorMessageDeleteRequest: string;
    loadingUpdateRequest: boolean;
    wasFetchedUpdateRequest: boolean;
    updateRequestData: Request;
    errorUpdateRequest: boolean;
    errorMessageUpdateRequest: string;
}

export const initialStateResult: Results = {
    solicitudes: [],
    funcionalidades: []
};

export const initialStateRequestList: RequestListResponse = {
    resultados: initialStateResult,
    total: 0,
    total_pagina: 0,
    conteo_total: 0
};

export const initialStateObject = {
    loadingRequest: false,
    wasFetchedRequest: false,
    requestResponseData: initialStateRequestList,
    errorRequest: false,
    errorMessageRequest: '',
    loadingEnterpriseAutocomplete: false,
    wasFetchedEnterpriseAutocomplete: false,
    enterpriseAutocompleteData: [],
    errorEnterpriseAutocomplete: false,
    errorMessageEnterpriseAutocomplete: '',
    loadingPostRequest: false,
    postRequestData: {} as Request,
    wasFetchedPostRequest: false,
    errorPostRequest: false,
    errorMessagePostRequest: '',
    loadingDeleteRequest: false,
    deleteRequestData: {} as Request,
    wasFetchedDeleteRequest: false,
    errorDeleteRequest: false,
    errorMessageDeleteRequest: '',
    loadingUpdateRequest: false,
    updateRequestData: {} as Request,
    wasFetchedUpdateRequest: false,
    errorUpdateRequest: false,
    errorMessageUpdateRequest: ''
};

const initialState: RequestLinkedBusinesses = initialStateObject;

export const requestLinkedBusinessesSlice = createSlice({
    name: 'listRequestLinkedBusinesses',
    initialState,
    reducers: {
        loadingRequest: (state) => {
            state.loadingRequest = true;
            state.errorRequest = false;
            state.errorMessageRequest = '';
            state.wasFetchedUpdateRequest = false;
            state.wasFetchedDeleteRequest = false;
            state.wasFetchedPostRequest = false;
        },
        requestStatusSuccess: (
            state,
            action: PayloadAction<RequestListResponse>
        ) => {
            state.loadingRequest = false;
            state.wasFetchedRequest = true;
            state.requestResponseData = action.payload;
        },
        requestStatusError: (state, action: PayloadAction<string>) => {
            state.loadingRequest = false;
            state.errorRequest = true;
            state.errorMessageRequest = action.payload;
        },
        loadingEnterprise: (state) => {
            state.loadingEnterpriseAutocomplete = true;
            state.errorEnterpriseAutocomplete = false;
            state.errorMessageEnterpriseAutocomplete = '';
        },
        loadingEnterpriseStop: (state) => {
            state.loadingEnterpriseAutocomplete = false;
            state.errorEnterpriseAutocomplete = false;
            state.errorMessageEnterpriseAutocomplete = '';
        },
        enterpriseStatusSuccess: (
            state,
            action: PayloadAction<Array<EnterpriseAutocomplete>>
        ) => {
            state.loadingEnterpriseAutocomplete = false;
            state.wasFetchedEnterpriseAutocomplete = true;
            state.enterpriseAutocompleteData = action.payload;
        },
        enterpriseStatusError: (state, action: PayloadAction<string>) => {
            state.loadingEnterpriseAutocomplete = false;
            state.errorEnterpriseAutocomplete = true;
            state.errorMessageEnterpriseAutocomplete = action.payload;
        },
        loadingPostRequest: (state) => {
            state.loadingPostRequest = true;
            state.errorPostRequest = false;
            state.wasFetchedPostRequest = false;
            state.errorMessagePostRequest = '';
        },
        postRequestStatusSuccess: (state, action: PayloadAction<Request>) => {
            state.loadingPostRequest = false;
            state.wasFetchedPostRequest = true;
            state.postRequestData = action.payload;
        },
        postRequestStatusError: (state, action: PayloadAction<string>) => {
            state.loadingPostRequest = false;
            state.errorPostRequest = true;
            state.errorMessagePostRequest = action.payload;
        },
        loadingDeleteRequest: (state) => {
            state.loadingDeleteRequest = true;
            state.errorDeleteRequest = false;
            state.wasFetchedDeleteRequest = false;
            state.errorMessageDeleteRequest = '';
        },
        deleteRequestStatusSuccess: (state, action: PayloadAction<Request>) => {
            state.loadingDeleteRequest = false;
            state.wasFetchedDeleteRequest = true;
            state.deleteRequestData = action.payload;
        },
        deleteRequestStatusError: (state, action: PayloadAction<string>) => {
            state.loadingDeleteRequest = false;
            state.errorDeleteRequest = true;
            state.errorMessageDeleteRequest = action.payload;
        },
        loadingUpdateRequest: (state) => {
            state.loadingUpdateRequest = true;
            state.errorUpdateRequest = false;
            state.wasFetchedUpdateRequest = false;
            state.errorMessageUpdateRequest = '';
        },
        updateRequestStatusSuccess: (state, action: PayloadAction<Request>) => {
            state.loadingUpdateRequest = false;
            state.wasFetchedUpdateRequest = true;
            state.updateRequestData = action.payload;
        },
        updateRequestStatusError: (state, action: PayloadAction<string>) => {
            state.loadingUpdateRequest = false;
            state.errorUpdateRequest = true;
            state.errorMessageUpdateRequest = action.payload;
        },
        clearError: (state) => {
            state.errorRequest = false;
            state.errorMessageRequest = '';
            state.errorEnterpriseAutocomplete = false;
            state.errorMessageEnterpriseAutocomplete = '';
        }
    }
});

export const {
    loadingRequest,
    requestStatusSuccess,
    requestStatusError,
    loadingEnterprise,
    loadingEnterpriseStop,
    enterpriseStatusSuccess,
    enterpriseStatusError,
    loadingPostRequest,
    postRequestStatusSuccess,
    postRequestStatusError,
    loadingDeleteRequest,
    deleteRequestStatusSuccess,
    deleteRequestStatusError,
    loadingUpdateRequest,
    updateRequestStatusSuccess,
    updateRequestStatusError,
    clearError
} = requestLinkedBusinessesSlice.actions;

export const useRequestLinkedBusinessSelector = () =>
    useSelector<AppState, RequestLinkedBusinesses>(
        ({ [requestLinkedBusinessesSlice.name]: slice }) => slice
    );

export const fetchRequestLinkedBusinessesThunk =
    (filters: Filters) =>
    async (dispatch: Dispatch): Promise<void> => {
        const axiosApi = axiosClient(`${import.meta.env.REACT_APP_API_ACHS}`);
        dispatch(loadingRequest());
        try {
            const response = await axiosApi.get('inicio/v1/solicitud', {
                params: filters,
                paramsSerializer: (params: any) => {
                    return qs.stringify(params);
                }
            });
            const requestLinkedBusinessesData: RequestListResponse =
                response.data;
            dispatch(requestStatusSuccess(requestLinkedBusinessesData));
        } catch (error: unknown) {
            if (axios.isAxiosError(error))
                dispatch(requestStatusError('error.response?.data.message'));
        }
    };

export const fetchEnterpriseAutocompleteThunk =
    (rutEmpresa: string, token: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        const axiosApi = axiosClient(`${import.meta.env.REACT_APP_API_ACHS}`);
        dispatch(loadingEnterprise());
        try {
            const response = await axiosApi.get(
                `/inicio/v1/empresa/autocompletado/${rutEmpresa}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            const enterpriseAutocompleteData: Array<EnterpriseAutocomplete> =
                response.data;
            dispatch(enterpriseStatusSuccess(enterpriseAutocompleteData));
        } catch (error: unknown) {
            if (error) {
                toast.error('Sin resultados encontrados', {
                    toastId: 'noData',
                    ...toastConfig
                });
                dispatch(enterpriseStatusError('Sin resultados encontrados'));
            }
            if (axios.isAxiosError(error))
                dispatch(requestStatusError('error.response?.data.message'));
        }
    };

export const stopLoading = (dispatch: Dispatch) => {
    dispatch(loadingEnterpriseStop());
};

export const postRequest =
    (body: BodyRequest, onCloseDrawer: () => void) =>
    async (dispatch: Dispatch): Promise<void> => {
        const axiosApi = axiosClient(`${import.meta.env.REACT_APP_API_ACHS}`);
        dispatch(loadingPostRequest);
        try {
            const response = await axiosApi.post('inicio/v1/solicitud', body);
            const result: Request = response.data;
            dispatch(postRequestStatusSuccess(result));
            onCloseDrawer();
            toast.success('Enviaste tu solicitud a ' + result.nombreEmpresa, {
                toastId: 'sendData',
                ...toastConfig
            });
        } catch (error: any) {
            if (error.toString().search('409') !== -1) {
                toast.error('Solicitud ya enviada o aceptada', {
                    toastId: 'errorSendData',
                    ...toastConfig
                });
            }
            if (axios.isAxiosError(error)) {
                dispatch(
                    postRequestStatusError('error.response?.data.message')
                );
            }
        }
    };

export const deleteRequest =
    (requestId: number, onCloseDrawer: () => void) =>
    async (dispatch: Dispatch): Promise<void> => {
        const axiosApi = axiosClient(`${import.meta.env.REACT_APP_API_ACHS}`);
        dispatch(loadingDeleteRequest);
        try {
            const response = await axiosApi.delete(
                `inicio/v1/solicitud/${requestId}`
            );
            const result: Request = response.data;
            dispatch(deleteRequestStatusSuccess(result));
            onCloseDrawer();
            toast.success('Eliminaste tu solicitud a ' + result.nombreEmpresa, {
                toastId: 'deleteData',
                ...toastConfig
            });
        } catch (error: unknown) {
            if (axios.isAxiosError(error)) {
                dispatch(
                    deleteRequestStatusError('error.response?.data.message')
                );
            }
        }
    };

export const updateRequest =
    (requestId: number, body: BodyUpdate, onCloseDrawer: () => void) =>
    async (dispatch: Dispatch): Promise<void> => {
        const axiosApi = axiosClient(`${import.meta.env.REACT_APP_API_ACHS}`);
        dispatch(loadingUpdateRequest);
        try {
            const response = await axiosApi.put(
                `inicio/v1/solicitud/${requestId}`,
                body
            );
            const result: Request = response.data;
            dispatch(updateRequestStatusSuccess(result));
            onCloseDrawer();
            toast.success(
                'Modificaste tu solicitud a ' + result.nombreEmpresa,
                {
                    toastId: 'edit',
                    ...toastConfig
                }
            );
        } catch (error: unknown) {
            if (axios.isAxiosError(error)) {
                dispatch(
                    updateRequestStatusError('error.response?.data.message')
                );
            }
        }
    };
